module.exports = __webpack_public_path__ + "static/media/image_20.9aa8eed6.png";